import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

import Sidebar from "./Sidebar";
import Head from "./Head";
function Layout() {
  // Initialize sidebar state: open on desktop (>=1024px), closed on mobile
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window !== "undefined") {
      return window.innerWidth >= 1024;
    }
    return true; // Default to open for SSR
  });

  useEffect(() => {
    const handleResize = () => {
      // On desktop, keep sidebar open; on mobile, close it
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    // Set initial state on mount
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="flex flex-row bg-neutral-100 h-screen w-screen overflow-hidden">
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={closeSidebar}
        />
      )}
      <div className="flex flex-col flex-1 overflow-y-auto">
        <Head className="sticky top-0 bg-white z-10" onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
        <div className="p-4 overflow-x-auto">{<Outlet />}</div>
      </div>
    </div>
  );
}

export default Layout;
